import { VatRate } from '../types/vatRate'

export const findVatRateById = (vatRates: VatRate[], id?: string): VatRate | undefined =>
  id ? vatRates.find((rate) => rate?.predefinedTag === id || rate?.id === id) : undefined
